import React, { useCallback, useEffect } from 'react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest, msalInstance } from '../config/MsalConfig';
import microsoftLogo from '../assets/microsoft.png';
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.scss';

const Login: React.FC = () => {
  const navigate = useNavigate();

  const getAccessToken = useCallback(async () => {
    const account = msalInstance.getAllAccounts()[0];
    try {
      const response = await msalInstance.acquireTokenSilent({
        account,
        scopes: loginRequest.scopes,
      });
      localStorage.setItem('msalToken', response.accessToken);
      navigate('/data-selection', { replace: true });
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({ scopes: loginRequest.scopes });
      } else {
        console.error('Silent token acquisition failed:', error);
      }
    }
  }, [navigate]);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
          localStorage.setItem('msalToken', response.accessToken);
          navigate('/data-selection', { replace: true });
        } else {
          const account = msalInstance.getAllAccounts()[0];
          if (account) await getAccessToken();
        }
      } catch (error) {
        console.error('Redirect handling failed:', error);
      }
    };
    void handleRedirect();
  }, [getAccessToken, navigate]);

  const loginWithRedirect = () => {
    msalInstance.loginRedirect({ scopes: loginRequest.scopes });
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logoMark}>
          <span>M</span>
        </div>

        <h1 className={styles.heading}>Master Data</h1>
        <p className={styles.subheading}>Sign in to continue</p>

        <div className={styles.divider} />

        <button type="button" className={styles.button} onClick={loginWithRedirect}>
          <img src={microsoftLogo} alt="" className={styles.buttonLogo} />
          Sign in with Microsoft
        </button>

        <p className={styles.footer}>
          Access restricted to authorized accounts.<br />
          Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
};

export default Login;